import React from 'react';

import { userRiskFactorStyle } from './RiskFactor.style';

import { formatWithCommas } from '@/shared/utils/helpers';

export type RiskFactorProps = {
    riskFactor: number;
};

const MAX_RISK_FACTOR_BEFORE_LIQUIDATED = 1;

export const RiskFactor = ({ riskFactor }: RiskFactorProps) => {
    const classes = userRiskFactorStyle();
    const colorClass = riskFactor >= MAX_RISK_FACTOR_BEFORE_LIQUIDATED ? classes.good : classes.bad;
    return (
        <div className={colorClass}>
            {formatWithCommas(
                Number(riskFactor)
                    .toFixed(4)
                    .replace(/\.?0+$/, ''),
            )}
        </div>
    );
};
